export default __webpack_public_path__ + "static/caressReflection-18014b7e096ff7f202be030413155203.svg";